const TEST_STATION	= /^[a-zA-Z0-9]+$/g,
	  TEST_CARGROUP	= /^[a-zA-Z0-9]+$/g,
	  TEST_DATE 	= /^[0-9]{4}-[0-9]{2}-[0-9]{2} [0-9]{1,2}:[0-9]{1,2}$/g;

const API_CACHETIME 	= 60 * 1000; // 10 Sekunden


function getDefaultStartdate(date_padding){
	if(!date_padding) date_padding = 60 * 60 * 1 * 1000;
	return new Date(new Date().getTime() + date_padding);
}

function getDefaultEnddate(date_padding){
	if(!date_padding) date_padding = 60 * 60 * 24 * 1000;
	return new Date(new Date().getTime() + date_padding);
}






export {API_CACHETIME, TEST_STATION, TEST_CARGROUP, TEST_DATE, getDefaultStartdate, getDefaultEnddate}




// WEBPACK FOOTER //
// ./src/store/orm/config.js